import { lazy, Suspense } from 'react';
import { Navbar } from '@/components/Navbar';
import { Hero } from '@/components/Hero';
import { WhatsAppButton } from '@/components/WhatsAppButton';
import { SEOHead, organizationSchema, websiteSchema } from '@/components/SEOHead';
import { LazySection } from '@/components/LazySection';

// Lazy-load all below-fold sections
const Marquee = lazy(() => import('@/components/Marquee').then(m => ({ default: m.Marquee })));
const InstitutionalSection = lazy(() => import('@/components/InstitutionalSection').then(m => ({ default: m.InstitutionalSection })));
const SolutionsSection = lazy(() => import('@/components/SolutionsSection').then(m => ({ default: m.SolutionsSection })));
const HumanizedSection = lazy(() => import('@/components/HumanizedSection').then(m => ({ default: m.HumanizedSection })));
const SocialProofSection = lazy(() => import('@/components/SocialProofSection').then(m => ({ default: m.SocialProofSection })));
const TestimonialsSection = lazy(() => import('@/components/TestimonialsSection').then(m => ({ default: m.TestimonialsSection })));
const DiagnosticSection = lazy(() => import('@/components/DiagnosticSection').then(m => ({ default: m.DiagnosticSection })));
const BlogSection = lazy(() => import('@/components/BlogSection').then(m => ({ default: m.BlogSection })));
const Footer = lazy(() => import('@/components/Footer').then(m => ({ default: m.Footer })));

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Núcleo - Economia Tributária Inteligente"
        description="Economia tributária inteligente para empresas de Lucro Real. Desde 2006 gerando economia para você investir em seu negócio."
        path="/"
        jsonLd={[organizationSchema, websiteSchema]}
      />
      <Navbar />
      <main>
        <Hero />

        {/* Near-fold: loads soon after hero */}
        <LazySection rootMargin="200px" minHeight="60px">
          <Suspense fallback={null}>
            <Marquee />
          </Suspense>
        </LazySection>

        {/* Each section loads independently when approaching viewport */}
        <LazySection rootMargin="400px" minHeight="400px">
          <Suspense fallback={null}>
            <InstitutionalSection />
          </Suspense>
        </LazySection>

        <LazySection rootMargin="300px" minHeight="600px">
          <Suspense fallback={null}>
            <SolutionsSection />
          </Suspense>
        </LazySection>

        <LazySection rootMargin="300px" minHeight="200px">
          <Suspense fallback={null}>
            <SocialProofSection variant="blue" />
          </Suspense>
        </LazySection>

        <LazySection rootMargin="300px" minHeight="400px">
          <Suspense fallback={null}>
            <HumanizedSection />
          </Suspense>
        </LazySection>

        <LazySection rootMargin="300px" minHeight="200px">
          <Suspense fallback={null}>
            <SocialProofSection />
          </Suspense>
        </LazySection>

        <LazySection rootMargin="300px" minHeight="600px">
          <Suspense fallback={null}>
            <TestimonialsSection />
          </Suspense>
        </LazySection>

        <LazySection rootMargin="300px" minHeight="300px">
          <Suspense fallback={null}>
            <DiagnosticSection />
          </Suspense>
        </LazySection>

        <LazySection rootMargin="300px" minHeight="500px">
          <Suspense fallback={null}>
            <BlogSection />
          </Suspense>
        </LazySection>
      </main>

      <LazySection rootMargin="200px" minHeight="200px">
        <Suspense fallback={null}>
          <Footer />
        </Suspense>
      </LazySection>

      <WhatsAppButton />
    </div>
  );
};

export default Index;
